import EventsEmitter from '../services/eventsEmitter';
import { addToGameLoop, removeFromGameLoop } from './gameLoop';

let app;
class Event {
  constructor(delay = 0, callback = () => {}, context, loop = false, repeatCount = 1, ...args) {
    this.time = performance.now() + delay;
    this.delay = delay;
    this.callback = callback;
    this.context = context;
    this.args = args;
    this.loop = loop;
    this.repeatCount = repeatCount;
    this.counter = 0;
  }

  changeDelay(newDelay = 0) {
    this.time -= this.delay;
    this.delay = newDelay;
    this.time += newDelay;
  }
}
export class Timer extends EventsEmitter {
  constructor() {
    super();
    this._events = [];
    this.ticker = app.ticker;
  }

  add(delay, callback, context, loop, repeatCount, ...args) {
    if (this._events.length === 0) addToGameLoop(this._update, this);
    const event = new Event(delay, callback, context, loop, repeatCount, ...args);
    this._events.push(event);
    return event;
  }

  remove(timerEvent) {
    const index = this._events.indexOf(timerEvent);
    if (index > -1) {
      this._events.splice(index, 1);
      if (this._events.length === 0) removeFromGameLoop(this._update, this);
    }
  }

  _update(time) {
    const eventsToRemove = [];
    this._events.forEach((event) => {
      if (time >= event.time) {
        event.callback.call(event.context, ...event.args);
        event.counter++;
        event.time = time + event.delay;
        if (event.loop === false && event.counter >= event.repeatCount) eventsToRemove.push(event);
      }
    });
    eventsToRemove.forEach((event) => {
      const index = this._events.indexOf(event);
      if (index > -1) this._events.splice(this._events.indexOf(event), 1);
    });
  }

  updateEventsTimes(delaysFromNow) {
    this._events.forEach((event, index) => {
      if (delaysFromNow[index] !== undefined) event.time = performance.now() + delaysFromNow[index];
    });
  }

  destroy() {
    if (this._events.length === 0) removeFromGameLoop(this._update, this);
    this._events.length = 0;
    // this.ticker = null;
  }

  accelerate(delaysFromNow = []) {
    this.updateEventsTimes(delaysFromNow);
  }
}
let gameTimer;
export function initGameTimer(a) {
  app = a;
  gameTimer = new Timer();
}

export function addToGameTimer(delay, callBack, context) {
  return gameTimer.add(delay, callBack, context, false);
}
export function addLoopToGameTimer(delay, callBack, context) {
  return gameTimer.add(delay, callBack, context, true);
}
export function removeFromGameTimer(timerEvent) {
  gameTimer.remove(timerEvent);
}
